import { createApp } from 'vue';
import App from './App.vue'; // Assuming your App component is located here
import '../src/firebase.js'
import './globals.css'
import router from './router';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { ref } from 'vue';

const isAuthInitialized = ref(false);
const auth = getAuth();

onAuthStateChanged(auth, (user) => {
    if (user) {
        // console.log('User is signed in:', user);
    } else {
        console.log('No user is signed in.');
    }
    isAuthInitialized.value = true;
});

const appInstance = createApp(App);
appInstance.use(router);
appInstance.mount('#app');
